'use client';

import React from 'react';
import { MainContent } from './MainContent';
import { ToolId } from './utils/slugs';
import { BlogPost } from '../data/blogPosts';

import { useRouter } from 'next/navigation';

interface Props {
    activeTool: ToolId;
    activePost: BlogPost | null;
}

export const MainContentWrapper: React.FC<Props> = ({ activeTool, activePost }) => {
    const router = useRouter();

    const handleNavigate = (path: string) => {
        router.push(path);
    };

    const setActiveTool = () => {};

    return (
        <MainContent
            activeTool={activeTool}
            setActiveTool={setActiveTool}
            activePost={activePost}
            handleNavigate={handleNavigate}
        />
    );
};
